import Vue from 'vue'
import axios from 'axios'
import { getCookie } from "../util/util"
import { Message } from 'element-ui'
import { getsign } from './rsasign'
import { appId, sn } from './key'
import { cryptoEncrypt, cryptoDecrypt } from './aes'

Vue.use('Message')

var regx = new RegExp(`(jys/pay/cart|jys/pay)$`, 'i')
//请求地址
axios.defaults.baseURL = process.env.API_ROOT

//请求拦截
axios.interceptors.request.use(config => {
  let ende = regx.test(config.url)
  //config.headers['token'] = Vue.cookie.get('token')
  let timeStamp = new Date().getTime()
  config.headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'token': getCookie("_token"),
    "pcKey": getCookie("pc")
  }
  // axios拦截器统一在接口增加时间戳参数，防止走缓存
  if (config.method == 'post') {
    config.data = {
      ...config.data,
      _t: Date.parse(new Date()) / 1000
    }
  } else if (config.method == 'get') {
    config.params = {
      ...config.params,
      _t: Date.parse(new Date()) / 1000
    }
  }
  let data = config.method == 'post' ? config.data : config.params
  if (ende && config.method == 'get') {
    let keys = Object.keys(data)
    keys.sort()
    let result = {}
    for (let i = 0; i < keys.length; i++) {
      result[keys[i]] = data[keys[i]]
    }
    data = result
  }
  if (ende) {
    config.headers["ZJ-AppId"] = appId
    config.headers["ZJ-Timestamp"] = timeStamp.toString()
    config.headers["ZJ-Sign"] = getsign(`${appId}_${timeStamp}_${JSON.stringify(data)}`)
    config.method == 'post' ? config.data = cryptoEncrypt(JSON.stringify(data), sn) : config.params = cryptoEncrypt(JSON.stringify(data), sn)
  }

  return config
}, error => {
  return Promise.reject(error)
})

//响应拦截
axios.interceptors.response.use(response => {
  if (regx.test(response.config.url)) {
    let data = cryptoDecrypt(response.data, sn)
    if (typeof data === 'string') {
      response.data = JSON.parse(data)
    } else {
      response.data = data
    }
  }
  if (response.data && response.data.code === 401) {
    Vue.prototype.$message({
      showClose: true,
      message: '请重新登录',
      type: 'error'
    });
  }
  return response
}, error => {
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/axios/axios.js